import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Heading, Text } from "@cinch-labs/design-system";
import { FeatureCard } from "./feature-card/feature-card";
import styles from "./feature-section.module.css";
import { Wrapper } from "@cinch-nx/shared-ui";
export const FeatureSection = ({ title , body , cards  })=>/*#__PURE__*/ _jsxs(Wrapper, {
        backgroundColor: "#F2F5FF",
        className: {
            container: styles.container,
            inner: styles.inner
        },
        isFluid: true,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                element: "h2",
                className: styles.title,
                children: title
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.body,
                children: body
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.cards,
                children: Array.isArray(cards) && cards.length >= 3 && cards.map((card)=>/*#__PURE__*/ _createElement(FeatureCard, {
                        ...card,
                        key: card.title
                    }))
            })
        ]
    });
